import xorWith from 'lodash-es/xorWith';
import isEmpty from 'lodash-es/isEmpty';
import isEqual from 'lodash-es/isEqual';

export const isArrayOfObjectsEqual = (array1, array2) => {
  isEmpty(xorWith(array1, array2, isEqual));
};
